<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("user_guest.search") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="text"
                  class="form-control"
                  v-on:keyup.enter="onSearchCustomer"
                  :placeholder="$t('user_guest.full_name')"
                  v-model="search.full_name"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-mobile"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    v-on:keyup.enter="onSearchCustomer"
                    :placeholder="$t('user_guest.phone')"
                    v-model="search.phone"
                  />
                </div>
              </div>
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="text"
                  class="form-control"
                  v-on:keyup.enter="onSearchCustomer"
                  :placeholder="$t('user_guest.identification')"
                  v-model="search.identification"
                />
              </div>
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4"></div>
              <div class="col-sm-4 col-md-4 col-lg-4"></div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchCustomer"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border" style="width:100%">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("user_guest.title_list") }}</b>
              <lte-button
                @click="callback()"
                style="float:right;background-color:white !important; margin-right: 50px"
                type="btn btn-default"
                right_icon="fa fa-plus"
                >{{ $t("user.createnew") }}</lte-button
              >
            </div>
            <select-option-check
              style="margin-top:-40px;"
              :item="columnsUserguest"
              class="dropdown-trigger"
              data-icon="eye"
            ></select-option-check>
          </div>
          <div class="box-body">
            <lte-table
              :hdBackground="hdBackground"
              @actions="crudActions"
              @onClickItemRow="onClickItemRow"
              :data="gridUserGuestDataList"
              :actions="
                this.GET_ACCOUNT_DATA.id == 1 ? actions : ['common.modify']
              "
              :columns="gridColumns"
              :customColumns="customColumns"
            ></lte-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
      </row>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!-- modal-confirm-user-guest-out-of-project -->
    <div class="modal fade" id="modal-confirm-user-guest-out-of-project">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4>
              {{ $t("common.delete_modal.content_with_param") }} khách hàng
              {{ user_guest_last_name }}
              {{ $t("common.confirm_delete_email_out") }}
            </h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="remove_user(user_guest_deleted_id)"
              class="btn btn-primary btn-sm pull-right"
            >
              Xác Nhận
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal fade" id="modal-confirm-customer-out-of-project">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4>
              {{ $t("user_guest.confirm") }} {{ user_guest_name }}
              {{ $t("user_guest.confirm_in") }}
            </h4>
          </div>
          <div class="modal-footer">
            <button
              @click="onhandleConfirm(entryId)"
              type="button"
              class="btn btn-primary btn-sm pull-right"
            >
              Xác Nhận
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTETable from "@/components/LTETable.vue";
import utils from "@/lib/utils";
import Paginator from "@/components/Paginator.vue";
import LTEButton from "@/components/LTEButton.vue";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";

export default {
  name: "UserGuestList",
  data() {
    return {
      gridUserGuestDataList: [],
      currentPage: 1,
      totalRows: 1,
      entryId: 0,
      user_guest_deleted_id: null,
      user_guest_last_name: "",
      perPage: 50,
      isLoading: false,
      user_guest_name: "",
      isModalVisible: false,
      gridColumns: [
        { text: "user_guest.nonumber", isHidden: true },
        { text: "user_guest.full_name", isHidden: true },
        { text: "user_guest.phone", isHidden: true, wrapText: 'nowrap' },
        { text: "user_guest.identification", isHidden: true },
        { text: "user_guest.checkin", isHidden: true },
        { text: "user_guest.checkout", isHidden: true },
        { text: "user.is_active", isHidden: true }
      ],
      customColumns: {
        "user.is_active": {
          true: "btn-label label-success glyphicon glyphicon-ok",
          false: "btn-label label-danger glyphicon glyphicon-remove"
        }
      },
      actions: ["common.modify", "common.delete"],
      columnsUserguest: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      search: {
        full_name: "",
        phone: "",
        identification: ""
      },
      paginatorItem: {
        commit_function: "GET_USER_GUEST_LIST"
      },
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;"
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATOR",
      "PAGINATION",
      "GET_USER_GUEST_DATA",
      "GET_ACCOUNT_DATA",
      "GET_USER_GUEST_DETAIL_DATA"
    ])
  },
  watch: {
    GET_USER_GUEST_DATA: function() {
      this.gridUserGuestDataList = [];
      this.GET_USER_GUEST_DATA.forEach((user_guest, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let fullname = utils.getFullName(
          user_guest.first_name,
          user_guest.last_name
        );
        let id = user_guest.id;
        let phone = user_guest.phone[0];
        let identification = user_guest.identification;
        let checkin = utils.formatSqlDate(user_guest.checkin, null, "DD/MM/YYYY hh:mm A");
        let checkout = utils.formatSqlDate(user_guest.checkout, null, "DD/MM/YYYY hh:mm A");
        let confirm = user_guest.confirm;
        let data = {
          "user_guest.nonumber": nonumber,
          "user_guest.full_name": utils.capitalizeFirstInString(fullname),
          "user_guest.phone": phone,
          "user_guest.identification": identification,
          "user_guest.checkin": checkin,
          "user.is_active": confirm,
          "user_guest.checkout": checkout,
          id: id
        };
        this.gridUserGuestDataList.push(data);
        this.totalRows = this.gridUserGuestDataList.length;
        this.isLoading = false;
      });
    }
  },
  methods: {
    ...mapActions([
      "GET_USER_GUEST_LIST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "REMOVE_USER_GUEST",
      "GET_USER_GUEST_DETAIL_NAME",
      "UPDATE_USER_GUEST_STATUS"
    ]),
    callback: function() {
      this.$router.push({
        name: "UserGuestAdd",
        params: {
          id: 0
        }
      });
    },
    onClickItemRow: function(entryId) {
      this.entryId = entryId;
      this.GET_USER_GUEST_DETAIL_NAME({ id: entryId })
        .then(
          function(res) {
            let user_guest_name = res.first_name + " " + res.last_name;
            this.user_guest_name = user_guest_name;
          }.bind(this)
        )
        .catch(function() {}.bind(this));
      $("#modal-confirm-customer-out-of-project").modal("show");
    },
    onhandleConfirm: function(entryId) {
      this.UPDATE_USER_GUEST_STATUS({ id: entryId })
        .then(
          function() {
            this.isLoading = false;
            $("#modal-confirm-customer-out-of-project").modal("hide");
            this.SUCCESS_TOAST();
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_USER_GUEST_LIST(data);
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            $("#modal-confirm-customer-out-of-project").modal("hide");
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    onSearchCustomer: function() {
      const data = {
        params: {
          page: 1,
          full_name: this.search.full_name.trim(),
          phone: this.search.phone.trim(),
          identification: this.search.identification.trim()
        }
      };
      this.isLoading = true;
      this.GET_USER_GUEST_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    remove_user: function(id) {
      this.REMOVE_USER_GUEST({ id: id })
        .then(
          function() {
            $("#modal-confirm-user-guest-out-of-project").modal("hide");
            const data = {
              params: {
                page: 1
              }
            };
            this.GET_USER_GUEST_LIST(data);
            this.columnsUserguest.data_list = this.gridColumns;
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            $("#modal-confirm-user-guest-out-of-project").modal("hide");
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.GET_USER_GUEST_LIST(data);
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "UserGuestAdd",
          params: {
            id: recordData.id
          }
        });
      } else if (actionsType == LTEActionTypeEnum.DELETED) {
        this.user_guest_deleted_id = recordData.id;
        this.user_guest_last_name = recordData["user_guest.full_name"];
        $("#modal-confirm-user-guest-out-of-project").modal("show");
      } else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    }
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_USER_GUEST_LIST(data);
    this.columnsUserguest.data_list = this.gridColumns;
  },
  components: {
    "lte-table": LTETable,
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    "select-option-check": SelectOptionCheck
  }
};
</script>



// WEBPACK FOOTER //
// src/views/UserGuest/UserGuestList.vue